import { render } from "./index.vue?vue&type=template&id=68f44fc8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=68f44fc8&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f44fc8"]])

export default __exports__